<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="150px" >
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.demandDate')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.docNo')">
                <el-input v-model="requestNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row> 
  
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
        <el-row >  
          <Table :tableData="tableData" :linkAction="linkAction" @reload-data-by-sort="reloadDataBySort"/> 
        </el-row>
        
    </el-main>
  </div>
</template>

<script>
import Table from '../components/FuzzySearchTableWithRemoteSort'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindFeedbackListForCust } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

export default {
  name: 'customerFeedbackHandling',
  data() {    
    return {      
      sdate: '',
      edate: '',
      requestNo: '', 
      sortColumn:'',
      sortType:'',
      tableData: {
        columns: [
          { field: "requestNo", title: this.$i18n.t('field.docNo'), width: 180, link:true, align:'center'},         
          { field: "status", title: this.$i18n.t('field.status'), width:120 },
          { field: "applyAccount", title: this.$i18n.t('field.requestAccount'), width: 200  },  
          { field: "applyDate", title: this.$i18n.t('field.demandDate'), width: 150  },             
          { field: "sn", title: this.$i18n.t('field.serialNo'), width: 150 },
          { field: "symptom", title: this.$i18n.t('field.symptom'), width: 450 },
          { field: "fae", title: 'INCX FAE',align:'center', width: 150 },
          { field: "rmaNo", title: 'RMA Number', align:'center', width: 180 },
          { field: "productType", title: this.$i18n.t('field.productType'), width: 150 },   
          { field: "model", title: this.$i18n.t('field.model'), width: 135 },
          { field: "shippingDate", title: this.$i18n.t('field.shippingDate'), align:'center', width: 145 },
          { field: "panelReceivedDate", title:  this.$i18n.t('field.panelReceivedDate'), width: 190  }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'feedbackTable',
        exportName: this.$i18n.t('menu.customerFeedbackHandling')
      }     
    };
  },   
  components: {
    Breadcrumb,
    Table
  },
  mounted() {  
    this.findData('', false)
    
  },
  methods: {
    findData(condition, checkbox){
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
      }
       if(this.edate != null && this.edate != ''){        
        edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
      }
      
      apiFindFeedbackListForCust({ headers: authHeader(), sdate : sdate, edate : edate, no: this.requestNo, sortColumn: this.sortColumn, sortType: this.sortType}).then((response) => { 
        this.tableData.data = response.data;
        this.tableData.originalTableData =  this.tableData.data;
      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData(this.condition, this.checkbox);
    },  
    linkAction(row, index){            
      this.$router.push("/CreateFeedback/" + row.feedbackId);
    }
  },
  reloadDataBySort(sortColumn, sortType){
    this.sortColumn = sortColumn;
    this.sortType = sortType;
    this.findData()
  }   
};
</script>
